// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b77f4c9a","455":"23d58443","977":"a00ddad3"}[chunkId] + ".chunk.js";
};